/**
 * components/organism/DataTable/index.js
 */
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import clsx from 'clsx';
import { RefreshButton } from 'src/presentations/components/molecules/refreshButton';
import { cn } from 'src/utils/utility';
import Pagination from '../table/Pagination';
import { IFilterNavProps } from '../../organisms/dataTable/types';

const StyledTabs = styled(Tabs)({
  minHeight: 0,

  '& .MuiButtonBase-root': {
    color: '#808080',
  },
  '& .MuiButtonBase-root.Mui-selected': {
    color: '#202020',
  },
  '& .MuiTouchRipple-root': {
    color: '#00992B',
  },
  '& .MuiTabs-indicator': {
    height: 2,
  },
  '& .MuiTabs-flexContainer': {
    justifyContent: 'center',
  },
});

const FilterNav: React.FC<IFilterNavProps> = (props) => {
  const { options, isLoading, onChange, onRefresh, onChangePage, classNames, defaultSelected, isShowPagination, total, numberOfRows, params } = props;

  const [searchParams] = useSearchParams();
  const keyword = searchParams.get('invoiceId');
  const [selected, setSelected] = useState(defaultSelected);

  useEffect(() => {
    if (defaultSelected && !keyword) {
      setSelected(defaultSelected);
    } else if (keyword) {
      setSelected('');
    }
  }, [defaultSelected, keyword]);

  const handleChange = (event, newValue: string) => {
    setSelected(newValue);
    onChange(newValue);
  };

  return (
    <div className={clsx('flex items-center gap-32 px-[20px] pt-[12px] border-b border-neutral-20 justify-between bg-white', classNames)}>
      {isLoading ? (
        <span>...</span>
      ) : (
        <>
          <div className='flex items-center gap-32  border-neutral-20'>
            <StyledTabs value={selected} onChange={handleChange}>
              {options.map((option) => (
                <Tab
                  value={option?.value}
                  key={`landing-menu-${option?.value}`}
                  className='!py-16 !px-20 xl:!px-32 group'
                  disabled={!!keyword}
                  label={
                    <div className='flex flex-row items-center gap-10'>
                      <strong className='tracking-normal normal-case text-14 xl:text-16 font-semi-bold transition-all duration-300 group-hover:text-neutral-90'>
                        {option?.label}
                      </strong>
                      <span
                        className={cn(
                          '!text-12 xl:!text-14 rounded-full px-6 py-2 xl:py-3 font-medium transition-all duration-300 group-hover:bg-primary group-hover:text-white',
                          !keyword && selected === option?.value ? 'bg-primary text-white' : 'bg-neutral-20 text-neutral-50'
                        )}
                      >
                        {option?.count}
                      </span>
                    </div>
                  }
                />
              ))}
            </StyledTabs>
          </div>
          <div className='flex flex-row items-end'>
            {isShowPagination && (
              <div className='mr-16 xl:mr-24 pb-6'>
                <Pagination total={total} onChangePage={onChangePage} params={params} pageSize={numberOfRows} />
              </div>
            )}
            {onRefresh && <RefreshButton onClick={onRefresh} />}
          </div>
        </>
      )}
    </div>
  );
};

export default FilterNav;
